const syncCookieConsent = async () => {
	await fetch('/api/cookie/categories/', {
		method: 'DELETE',
		credentials: 'include'
	});
};

export default syncCookieConsent;
